import { Box, Portal } from "@mui/material";
import { FC, useEffect, useRef } from "react";
import { useDataCatalogContext } from "../dataCatalogContext/DataCatalogContext";

const PagerMask: FC = () => {
  const { criteriaLockedDown } = useDataCatalogContext()
  const pagerContainer = useRef<Element|null>(null)
  useEffect(() => {
    pagerContainer.current = document.querySelector('div.MuiTablePagination-toolbar')
  })
  return (
    criteriaLockedDown && pagerContainer.current ?
    <Portal container={pagerContainer.current}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 2,
          backgroundColor: 'transparent',
        }}
      >      
      </Box>
    </Portal> :
    null
  )
}

export default PagerMask;
